import { render, staticRenderFns } from "./MoveBtn.vue?vue&type=template&id=2abdd2ba&scoped=true&"
import script from "./MoveBtn.vue?vue&type=script&lang=js&"
export * from "./MoveBtn.vue?vue&type=script&lang=js&"
import style0 from "./MoveBtn.vue?vue&type=style&index=0&id=2abdd2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdd2ba",
  null
  
)

export default component.exports